module.exports = __webpack_public_path__ + "img/m_Polar Launch Site.c737ea95.png";